import React from "react";
import {
  MagnifyingGlassIcon,
  ArrowPathIcon,
} from "@heroicons/react/24/outline";
import ThemeSwitch from "../ThemeSwitch";

const TopBar = ({
  activeTab,
  navigationItems,
  onOpenSidebar,
  userSearch,
  onUserSearchChange,
  onUserSearchSubmit,
  onRefresh,
  refreshLoading,
}) => {
  const current = navigationItems.find((item) => item.id === activeTab);
  const title = current?.name || "Сату менеджері";
  const description = current?.description || "";

  return (
    <div className="sales-manager-topbar sticky top-0 z-30 flex items-center">
      <div className="flex items-center justify-between px-6 w-full h-full min-h-0">
        <div className="flex items-start space-x-4 min-w-0">
          <button
            type="button"
            onClick={onOpenSidebar}
            className="lg:hidden p-2 rounded-lg text-gray-400 hover:text-white hover:bg-gray-700 transition-all duration-200"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
          <div className="min-w-0 flex flex-col items-start justify-center">
            <h1 className="text-2xl font-bold bg-accent-grad bg-clip-text text-transparent">
              {title}
            </h1>
            {description ? (
              <p className="text-sm mt-0.5 text-[#4A4A4A] dark:text-[#E2E8F0]">
                {description}
              </p>
            ) : null}
          </div>
        </div>

        <div className="flex items-center space-x-3 shrink-0">
          {activeTab === "users" && (
            <div className="relative flex items-center">
              <div className="relative">
                <MagnifyingGlassIcon className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Пайдаланушыны іздеу..."
                  value={userSearch}
                  onChange={(e) => onUserSearchChange(e.target.value)}
                  onKeyPress={onUserSearchSubmit}
                  className="pl-10 pr-4 py-2.5 rounded-lg transition-all duration-200 w-64 border bg-[#F1F5F9] border-[#CED4DA] text-[#64748B] placeholder-[#94A3B8] focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-[#1C2126] dark:border-[#333333] dark:text-[#9CA3AC] dark:placeholder-[#64748B]"
                />
              </div>
            </div>
          )}

          <ThemeSwitch />

          <button
            type="button"
            onClick={onRefresh}
            className="w-[46px] h-[46px] rounded-full flex items-center justify-center shrink-0 border bg-[#F1F5F9] border-[#CED4DA] text-[#64748B] hover:opacity-90 transition-all duration-200 dark:bg-[#1C2126] dark:border-[#333333] dark:text-[#9CA3AC]"
            title="Жаңарту"
          >
            <ArrowPathIcon
              className={`w-5 h-5 ${refreshLoading ? "animate-spin" : ""}`}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
